/* 🤖 this file was generated by svg-to-ts */
export const matIconDriveFileRenameOutline: {
  name: 'drive-file-rename-outline';
  data: string;
} = {
  name: 'drive-file-rename-outline',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m15 16-4 4h10v-4zm-2.94-8.81L3 16.25V20h3.75l9.06-9.06-3.75-3.75zM5.92 18H5v-.92l7.06-7.06.92.92L5.92 18zm12.79-9.96a.996.996 0 0 0 0-1.41l-2.34-2.34a1.001 1.001 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>`
};
